import { render, staticRenderFns } from "./order_info.vue?vue&type=template&id=8df72a22&scoped=true"
import script from "./order_info.vue?vue&type=script&lang=js"
export * from "./order_info.vue?vue&type=script&lang=js"
import style0 from "./order_info.vue?vue&type=style&index=0&id=8df72a22&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df72a22",
  null
  
)

export default component.exports